<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div class="container py-3">
      <div class="row flex-nowrap pt-3 mx-2 justify-content-between align-items-center">
        <a href="https://www.chanchao.com.tw/vn/">
          <div class="d-flex align-items-center">
            <img src="../../assets/images/ChanChaoLogo.png" class="navLogo mt-2" />
            <div class="mx-2 logoText text-dark font-weight-nomal">
              <div>Hội viên Chan Chao</div>
            </div>
          </div>
        </a>

        <div class="d-flex mr-3">
          <a href="https://www.chanchao.com.tw/accounts/login">
            <img src="../../assets/images/langTW.svg" style="width: 17px; height: 17px" class="mb-1 mr-md-0 mr-2" />
            <span class="navEnText text-muted mr-3"> 中文版 </span>
          </a>

          <a href="https://www.chanchao.com.tw/accounts/en/login">
            <img src="../../assets/images/lang.svg" style="width: 17px; height: 17px" class="mb-1 mr-md-0 mr-2" />
            <span class="navEnText text-muted mr-3"> English </span>
          </a>

          <a href="https://www.chanchao.com.tw/accounts/th/login">
            <img src="../../assets/images/th.svg" style="width: 17px; height: 17px" class="mb-1" />
            <span class="navEnText text-muted ml-1"> ภาษาไทย </span>
          </a>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row formFrame m-1 py-2">
        <div class="lineRight col-md-7 mt-4 mb-md-4 mb-0 px-4">
          <div class="d-flex justify-content-between mb-4">
            <div class="d-flex align-items-center">
              <img src="../../assets/images/loginIcon.png" class="mr-2" style="width: 40px; height: 40px" alt="" />
              <h4 class="title_family">Hội viên đăng nhập</h4>
            </div>
          </div>

          <form>
            <div class="form-group h6">
              <label class="title_family" for="loginEmail">Địa chỉ email</label>
              <input
                type="email"
                class="form-control"
                name="email"
                maxlength="50"
                placeholder="Vui lòng nhập địa chỉ email bạn đã điền khi đăng ký tài khoản"
                id="loginEmail"
                aria-describedby="emailHelp"
                :class="{ 'is-invalid': errors.first('email') }"
                v-validate="'required|email'"
                v-model="email"
                ref="loginEmail"
              />
              <span class="text-danger title_family" style="font-size: 10px" v-if="errors.first('email')"
                >{{ errors.first('email') }}
              </span>
            </div>

            <div class="form-group h6">
              <label for="loginPassword" class="title_family">Mật khẩu</label>
              <div class="input-group mb-3">
                <input
                  :type="typePwd"
                  class="form-control"
                  name="password"
                  id="loginPassword"
                  autocomplete="off"
                  placeholder="Hãy nhập mật khẩu bạn đã cài đặt"
                  maxlength="20"
                  :class="{ 'is-invalid': errors.first('password') }"
                  v-model="password"
                  v-validate="'required'"
                  ref="loginPassword"
                />
                <div class="input-group-append">
                  <span class="input-group-text" id="basic-addon2" @click.prevent="showPw">
                    <i class="fas fa-eye" v-if="typePwd == 'password'"></i>
                    <i class="fas fa-eye-slash" v-else="typePwd == 'text'"></i>
                  </span>
                </div>
              </div>
              <span class="text-danger title_family" style="font-size: 10px" v-if="errors.first('password')"
                >Mật khẩu không được để trống
              </span>
            </div>

            <div class="form-group h6">
              <label for="loginPassword2" class="title_family">Mã xác thực</label>
              <div class="d-flex justify-content-around align-items-center">
                <input
                  type="text"
                  name="text"
                  maxlength="5"
                  placeholder="Mã xác thực không phân biệt chữ hoa, chữ thường"
                  class="form-control mr-1"
                  id="loginPassword2"
                  v-model="Validcode"
                  :class="{ 'is-invalid': errors.first('text') }"
                  v-validate="'required'"
                  ref="loginPassword2"
                />
                <img
                  :src="getsrc"
                  class="img-fluid rounded"
                  @click.prevent="resetValidcode"
                  style="width: 120px; height: 35px"
                />
                <a href="#" @click.prevent="resetValidcode">
                  <i class="ml-2 fas fa-redo" style="font-size: 25px"></i>
                </a>
              </div>
              <span class="text-danger title_family" style="font-size: 10px" v-if="errors.first('text')"
                >Mã xác thực không được để trống
              </span>
            </div>

            <div class="text-muted" style="font-size: 14px">
              <span>Đăng nhập đồng nghĩa với việc bạn đồng ý với </span>
              <a href="//www.chanchao.com.tw/en/otherMember.asp" target="_blank">điều khoản dịch vụ</a
              ><span> của chúng tôi</span>
            </div>

            <button type="submit" class="btn btn-block btn-primary mt-4" @click.prevent="loginBtn">Đăng nhập</button>
          </form>

          <hr />

          <div class="mb-1">Gặp khó khăn trong việc đăng nhập?</div>
          <div class="linkFrame">
            <a href="https://www.chanchao.com.tw/accounts/vn/forgetPw">Quên mật khẩu hoặc cài đặt lại mật khẩu</a>
            /
            <span class="MbDevice_inline">
              <router-link to="/vn/signup">Đăng ký ngay</router-link>
            </span>

            <span class="MbDevice_inline"> / </span>

            <a href="https://www.chanchao.com.tw/en/contact.asp" target="_blank"> Liên hệ CSKH</a>
          </div>
        </div>

        <div class="col-md-5 my-4 px-4 lineBottom">
          <QA />
        </div>
      </div>
    </div>
    <Footer />

    <router-view></router-view>
  </div>
</template>

<script>
  import QA from '@/components/QA_vn.vue'
  import Footer from '@/components/footer_en.vue'

  export default {
    components: {
      QA,
      Footer,
    },

    data() {
      return {
        getsrc: '',
        isLoading: false,
        typePwd: 'password',
        email: '',
        password: '',
        Validcode: '',
        CSRF_Token: '',
        redirect_url: '',
        alertTitle: '',
        alertText: '',
        access_token: '',
        lastUrl: '',
      }
    },

    watch: {
      Validcode: function () {
        const vm = this
        vm.$refs.loginPassword2.style.borderColor = '#ced4da'
      },

      email: function () {
        const vm = this
        vm.$refs.loginEmail.style.borderColor = '#ced4da'
      },

      password: function () {
        const vm = this
        vm.$refs.loginPassword.style.borderColor = '#ced4da'
      },
    },

    methods: {
      resetValidcode() {
        const vm = this
        vm.$http.get('https://www.chanchao.com.tw/apiLogin2/Validcode').then((response) => {
          vm.getsrc = response.data
        })
      },

      loginBtn() {
        const vm = this
        const url = 'https://www.chanchao.com.tw/apiLogin2/Login'
        const info = {
          login: vm.email,
          password: vm.password,
          Validcode: vm.Validcode,
          // uilang: 'vn',
          CSRF: vm.CSRF_Token,
        }

        vm.$validator.validate().then((valid) => {
          if (valid) {
            vm.$http.post(url, info).then(function (response) {
              // // console.log(response)
              if (response.data == '200') {
                if (vm.lastUrl) {
                  window.location.replace(vm.lastUrl)
                } else {
                  window.location.replace('https://www.chanchao.com.tw/vn/')
                }
              } else if (response.data == '252') {
                vm.alertText = 'Địa chỉ email không đúng！'
                vm.alertError()
                vm.$refs.loginEmail.style.borderColor = 'red'
              } else if (response.data == '253') {
                vm.alertText = 'Mật khẩu không đúng！'
                vm.alertError()
                vm.$refs.loginPassword.style.borderColor = 'red'
              } else if (response.data == '254') {
                vm.alertText = 'Mã xác nhận không đúng！'
                vm.alertError()
                vm.$refs.loginPassword2.style.borderColor = 'red'
              } else if (response.data == '255') {
                window.location.replace('https://www.chanchao.com.tw/vn/')
              } else if (response.data == '258') {
                vm.alertText = 'Vui lòng bật cookie trình duyệt của bạn và đăng nhập lại！'
                vm.alertError()
                vm.$refs.loginPassword2.style.borderColor = 'red'
              } else {
                vm.alertText = 'Hệ thống đang bận, vui lòng đăng nhập sau！'
                vm.alertError()
              }
            })
          } else {
            vm.alertText = 'Thông tin chưa hoàn thiện, xin vui lòng kiểm tra lại！'
            vm.alertError()
          }
        })
      },

      alertError() {
        const vm = this
        vm.$swal({
          title: vm.alertTitle,
          text: vm.alertText,
          icon: 'info',
          confirmButtonText: 'OK',
          // animation: false,
          allowOutsideClick: true,
          confirmButtonColor: '#abc6d2',
          width: 300,
          padding: 15,
        })
      },

      showPw() {
        const vm = this
        vm.typePwd = vm.typePwd === 'password' ? 'text' : 'password'
      },
    },

    created() {
      const vm = this

      vm.$http.get('https://www.chanchao.com.tw/apiLogin2/Validcode').then((response) => {
        vm.getsrc = response.data
      })

      vm.$http.get('https://www.chanchao.com.tw/apiLogin2/CSRF_Token').then((response) => {
        vm.CSRF_Token = response.data
      })

      //GET LANDING PAGE

      //取得上頁的網址
      //如果上頁網址有值，代表是非vue路徑裡，就執行驗證是否為展昭網域，如果是就存到LS再取出掛載至變數
      //如果上頁網址沒有值，就執行

      let lastPage = document.referrer
      let domain = lastPage.split('/')[2]
      let noaccount = lastPage.split('/')[3] //排除account Url
      let domain_head = domain.split('.')[1].split('.')[0]
      let first_head = domain.split('.')[0]

      //如果上一頁是展昭的網域，那就將此網址存到Cookie裡，並放在lastUrl變數裡
      //如果不是就存官網網址

      if (
        first_head == 'vtg' ||
        first_head == 'dtg' ||
        first_head == 'hanoiplas' ||
        first_head == 'vietnamprintpack' ||
        first_head == 'intelligentasia-thailand' ||
        first_head == 'vietnamplas' ||
        first_head == 'ipf' ||
        first_head == 'vietnamwood' ||
        first_head == 'automationtaipei' ||
        first_head == 'hanoiprintpack'
      ) {
        vm.lastUrl = vm.$cookies.get('RecordUrl')
      } else {
        if (lastPage && noaccount !== 'accounts') {
          if (domain == 'www.chanchao.com.tw' || domain_head == 'chanchao') {
            //如果網域為展昭

            vm.$cookies.set('url', lastPage, 60 * 60)
            vm.lastUrl = vm.$cookies.get('url')
          } else {
            vm.lastUrl = 'https://www.chanchao.com.tw/vn/' //如果不是展昭網域，就導回首頁
          }
        } else {
          if (vm.$cookies.get('url')) {
            vm.lastUrl = vm.$cookies.get('url')
          } else {
            vm.lastUrl = 'https://www.chanchao.com.tw/vn/'
          }
        }
      }

      //更換英文語系
      vm.$i18n.locale = 'vi'
    },
  }
</script>

<style lang="scss">
  //Swal

  .logoText {
    font-size: 20px;
  }
  .swal2-popup {
    font-size: 13px !important;
  }

  .swal2-styled.swal2-confirm {
    font-size: 10px;
  }

  .menuFrame {
    background-color: #f2f2f2;
    min-height: 100%;
    font-family: Arial; //內文字體
  }

  .title_family {
    font-family: 'sans-serif';
  }

  .formFrame {
    background-color: #ffffff;
    margin-top: 40px;
    border-radius: 10px;
    box-shadow: 1px 1px 1px 1px rgba(201, 199, 199, 0.5);
  }

  .lineRight {
    border-right: 1px solid #ccc;
  }

  .navEnText:hover {
    color: rgb(34, 34, 34) !important;
  }

  .navHead {
    font-size: 29px;
    color: #2c3e50;
  }

  .navCnt {
    font-size: 17px;
  }

  .navLogo {
    height: 55px;
  }

  .input-note {
    font-size: 14px;
    color: rgb(190, 67, 67);
  }

  .linkFrame {
    font-size: 15px;
  }

  .linkText {
    position: relative;
  }

  .linkLine {
    position: absolute;
    height: 13px;
    //width: 33px;
    top: 20%;
    left: 0;
    border-left: 2px solid #a1a7a8;
  }

  @media (max-width: 768px) {
    .navLogo {
      height: 50px;
    }
    .lineRight {
      border-right: 0px;
    }

    .lineBottom {
      border-top: 0.5px solid rgb(230, 227, 227);
    }

    .navEnText {
      display: none;
    }

    .navHead {
      font-size: 23px;
      color: #2c3e50;
    }

    .navCnt {
      font-size: 14px;
    }

    .logoText {
      font-size: 16px;
    }
  }

  @media (max-width: 992px) {
    .auth-code {
      margin-top: 20px;
      margin-bottom: 20px;
    }
  }
</style>
